export const statusByName2 = {
  'por hacer': 0,
  alta: 1,
  'en proceso': 2,
  terminado: 3,
  'en agenda': 4,
  practica: 5,
  notificaciones: 6,
  activation: 7,
  autorizacion: 8,
  pago: 9,
  ventas: 10,
  contratación: 11,
  'forma de pago': 13,
  'modificación G. Familiar': 14,
  otras: 15,
  'baja ': 16,
  'cambios_bajas ': 17,
  especialidades: 18,
};

export const statusByName = {
  'por hacer': 0,
  alta: 1,
  'en proceso': 2,
  terminado: 3,
  'en agenda': 4,
  practica: 5,
  notifications: 6,
  activation: 7,
  authorizations: 8,
  pago: 9,
  ventas: 10,
};

export const statusNames = {
  por_hacer: 'por hacer',
  alta: 'alta',
  en_proceso: 'en proceso',
  terminado: 'terminado',
  en_agenda: 'en agenda',
  practica: 'practica',
  activation: 'P. activación',
  authorizations: 'autorizaciones',
  pago: 'pago',
  ventas: 'ventas',
};

export const kinshipLabel = {
  0: 'OTRO',
  10: 'PAREJA',
  20: 'HIJO',
  30: 'AMIGO',
  40: 'PADRE/MADRE',
  50: 'SOBRINO/A',
  60: 'NIETO/A',
  70: 'ABUELO/A',
  80: 'HERMANO/A',
  90: 'TIO/A',
};

export const typeByName = {
  web: 0,
  whatsapp: 1,
};
